import { MRGE_GITHUB_REPO_OWNER } from '@/lib/constants';

export function shouldEnablePrV2CustomComparisonOrderedFiles(owner: string): boolean {
  return owner.toLowerCase() === MRGE_GITHUB_REPO_OWNER;
}
